<div class="d-flex align-items-center min-vh-100">
    <div class="container text-center" dir="auto">
      <p class="display-4">{{'Thanksforyourpurchase'|translate}}</p>
      <p>{{'Yourorderid'|translate}} <span class="text-success">#{{order?.id}}</span>, {{'contactUsTrack'|translate}}.</p>
      <p>{{'trackYour'|translate}}.</p>
    </div>
</div>
  